import { render } from "./EmailTemplate.vue?vue&type=template&id=27dcbc76&scoped=true"
import script from "./EmailTemplate.vue?vue&type=script&lang=js"
export * from "./EmailTemplate.vue?vue&type=script&lang=js"

import "./EmailTemplate.vue?vue&type=style&index=0&id=27dcbc76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27dcbc76"]])

export default __exports__